var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6484 7.79688C14.0938 8.24219 14.0938 8.96875 13.6484 9.39062L8.86719 14.1719C8.44531 14.6172 7.71875 14.6172 7.27344 14.1719L2.32812 9.22656C2.11719 9.01562 2 8.73438 2 8.42969V3.625C2 3.01562 2.49219 2.5 3.125 2.5H7.90625C8.21094 2.5 8.49219 2.64062 8.70312 2.85156L13.6484 7.79688ZM8.07031 13.375L12.875 8.59375L7.90625 3.625H3.125V8.42969L8.07031 13.375ZM6.5 5.875C6.5 6.50781 5.98438 7 5.375 7C4.74219 7 4.25 6.50781 4.25 5.875C4.25 5.26562 4.74219 4.75 5.375 4.75C5.98438 4.75 6.5 5.26562 6.5 5.875Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/listIcon.6d9a21b0bcff0b3ef6bd0026ee5e031d.svg";
export { ForwardRef as ReactComponent };